import { z } from 'zod';
import { SweetShopArticleCategoryModelSchema } from 'entities/sweet-shop-article-category';
import { GetSweetShopArticleCategoryByUidApiResponseSchema } from '../store';

export const createSweetShopArticleCategoryFromGetSweetShopArticleCategoryByUidApiResponse = (
    (response: z.infer< typeof GetSweetShopArticleCategoryByUidApiResponseSchema>) => (
        SweetShopArticleCategoryModelSchema.parse({
            uid: response.data.slug,
            name: response.data.name,
            description: response.data.description,
            addictionalDescription: response.data.addictionalDescription,
            image: response.data.image && {
                url: response.data.image.url,
            },
        })
    )
);
